import React from 'react';
import {Typography,Container, Paper,ThemeProvider} from '@mui/material';
import TrendingImg from './topArt';
import { howItWork } from './gadgets';
import Testimonies from './testimonies';
import Theme from './thene';
import Faqs from './subCom/faqs'
import WorkTrend from './subCom/offer';
const Main = () => {
    
    return (
      <ThemeProvider theme={Theme}>
            
      <Container>
      <div className='textHeader'>
        
      <h1> kenneth art, we make it our top priority to trend with art.</h1> 
      <h3>feel free to make your choice , your satisfaction is our concern.</h3>
          </div>
      
          <div className="line"></div>
          <TrendingImg />
          <div className="productheader">
                 <h1>
                     
           how it works 
              </h1>
              </div>
          {howItWork.map((item, index) => {
              return (
          <Paper key={index} sx={{marginTop:4}} elavation={6}>
              <ul>
                  <li>
                      <Typography sx={{ textTransform: 'capitalize' }}>
                         {item.info}
                      </Typography>
                  </li>
          </ul>
          </Paper>
                  
              )
          })}
                <WorkTrend/>
 <div className="productheader">
                 <h1>
                     
           testimonies
                 </h1>
          </div>
                <Testimonies />
                <Faqs/>
    </Container>
      </ThemeProvider>
  );
}

export default Main;
